module.exports = __webpack_public_path__ + "img/checkbox-unchecked.67141434.svg";